<template>
<ValidationObserver ref="observer">
  <form ref="add_dp_amount_form" @submit.prevent="addDpAmount">

    <md-card>
      <md-card-content>
        <!-- <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="dpamounttype" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>DP Type</label>
                  <md-select v-model="dp_amount_type" required>
                    <md-option value="0">Yellow Plate</md-option>
                    <md-option value="1">Black Plate</md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.dp_amount_type" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div> -->

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="dpamountname" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>DP Amount Name</label>
                  <md-input v-model="dp_amount_name" required/>
                  <validation-error :errors="apiValidationErrors.dp_amount_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item">
            <validation-provider rules="dpamountvehicletype" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Vehicle Type</label>
              <md-input v-model="dp_amount_vehicle_type_view" required readonly/>
              <validation-error :errors="apiValidationErrors.dp_amount_vehicle_type" />
              <md-button style="background-color:green;" class="md-icon-button md-info md-dense" v-on:click="findVehicleType">
                <md-icon >search</md-icon>
              </md-button>
            <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="dpamountamount" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Amount</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="dp_amount" required/>
                  <validation-error :errors="apiValidationErrors.dp_amount" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
        
      </md-card-content>
      <modal ref="modalListVehicleType" class="coba">
        <template v-slot:header>
          <div>
            <h3>List Vehicle</h3>
          </div>
          <md-button class="md-dense md-round md-icon-button" @click="CloseList()"><md-icon>close</md-icon></md-button>
        </template>
        
        <template v-slot:body>
          <list-vehicle-type :data_id="$refs.modalListVehicleType.data"/>
        </template>
      </modal>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import ListVehicleType from "@/pages/Dashboard/Fms/DpAmount/Modal/ListVehicleType.vue";
import { Modal } from "@/components";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend('dpamountname', {
  ...required,
  message: 'Name Field is required'
});
extend('dpamounttype', {
  ...required,
  message: 'Type Field is required'
});
extend('dpamountvehicletype', {
  ...required,
  message: 'Vehicle Type field is required'
});
extend('dpamountamount', {
  ...required,
  message: 'Amount field is required'
});
  
  export default {
     name: "add-dp-amount",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver, Modal, "list-vehicle-type" : ListVehicleType},

    mixins: [formMixin],

    data: () => ({
      dp_amount_vehicle_type_view: null,
      dp_amount_name: null,
      dp_amount: null,
      dp_amount_type:null
    }),

    // created() {
    //   this.getLastNo();
    // },

  
    methods: {


      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Dp Amount' })
    },

    findVehicleType(){
      this.$refs.modalListVehicleType.openModal()
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    modalCloseListVehicleType(data,brand){
      console.log(data)
      if(data.id){
       this.dp_amount_vehicle_type = data.id
       this.dp_amount_vehicle_type_view = brand+' '+ data.vehicle_model +'-'+  data.vehicle_year_model
      }
      this.$refs.modalListVehicleType.closeModal()
    },

    CloseList(){
      this.$refs.modalListVehicleType.closeModal();
    },

     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addDpAmount()
          }
        });
    },


    // fungsi add data
      async addDpAmount() {
       

        const data = {
          type: "fms_dp_amounts",
          // client_no: this.client_no,
          dp_amount_name: this.dp_amount_name,
          dp_amount: this.dp_amount,
          
          dp_amount_type: 0,
          dp_amount_vehicle_type: this.dp_amount_vehicle_type
        }


        try {
        await this.$store.dispatch("fms_dp_amount/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // await this.$router.replace({name: 'List Dp Amount'});
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
<style lang="scss" scoped>
  .coba {
    width: 800px !important;
    // margin:  !important;
    // top: auto !important;
    // bottom: 50px !important;
    z-index:9999 !important;
  
    
  }
  @media screen and (max-width: 992px) {
    .coba {
      width: 90% !important;
      z-index:9999 !important;
    }
  }
  </style>
